import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../constants';
import { useAuth } from '../../context/authContext';

const SessionExpiredOverlay = () => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { expireSession } = useAuth();

  const goLogin = React.useCallback(() => {
    try {
      const path = `${window.location.pathname}${window.location.search}${window.location.hash}` || '/';
      localStorage.setItem('postLoginRedirect', path);
      localStorage.setItem('sessionExpired', '1');
      expireSession();
    } catch {}
    navigate(ROUTES.LOGIN);
  }, [navigate, expireSession]);

  React.useEffect(() => {
    const key = localStorage.getItem('sessionExpired');
    if (key === '1') {
      setOpen(true);
      // auto navigate to login to satisfy requirement #2
      goLogin();
    }
    const handler = () => {
      setOpen(true);
      goLogin();
    };
    window.addEventListener('session-expired', handler);
    return () => window.removeEventListener('session-expired', handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!open) return null;

  return (
    <ModalWrapper
      open={open}
      setOpen={setOpen}
      title={t('GENERAL.SESSION_EXPIRED')}
      subtitle={t('GENERAL.YOUR_SESSION_HAS_EXPIRED_PLEASE_LOG_IN_AGAIN_TO_CONTINUE')}
      content={
        <Box>
          <Typography variant="body1" sx={{ mb: 2 }}>
            You will be redirected to the login page.
          </Typography>
        </Box>
      }
      actions={
        <Button variant="contained" color="primary" onClick={goLogin}>
          {t('GENERAL.GO_TO_LOGIN')}
        </Button>
      }
      width="420px"
    />
  );
};

export default SessionExpiredOverlay;
